import { cacheKey, prefetch } from "@/lib/dataCache";
import { api } from "@/lib/api";
import { prefetchProductImage, prefetchProductImages } from "@/lib/images";

/** Warm product detail + hero images before the user lands on the PDP. */
export function prefetchProductDetail(productId, coverImage) {
  if (!productId) return;
  if (coverImage) prefetchProductImage(coverImage, "md");

  const key = cacheKey(["product", productId]);
  prefetch(key, () =>
    api.get(`/products/${productId}`).then((r) => {
      const data = r.data;
      const product = data?.product;
      if (product) {
        const imgs = product.images?.length
          ? product.images
          : product.image
            ? [product.image]
            : [];
        prefetchProductImages(
          imgs.map((image) => ({ image })),
          { limit: 4, variant: "md" }
        );
      }
      return data;
    })
  );
}
